<template>
  <div
    class="bg-light footer"
    v-if="!user.id && !aceiteRealizado"
    data-cy="footer-container"
  >
    <b-row align-v="center" align-h="center" data-cy="footer-row">
      <b-col cols="auto" data-cy="footer-col-text">
        <span data-cy="footer-text">
          Ao continuar a usar este site, você concorda com nossa
          <a
            target="_blank"
            :href="urls.politicaPrivacidadeLink"
            data-cy="link-politica-privacidade"
          >
            Política de Privacidade
          </a>
          e com os nossos
          <a
            target="_blank"
            :href="urls.termoUsoLink"
            data-cy="link-termos-uso"
          >
            Termos de Uso
          </a>.
        </span>
      </b-col>
      <b-col cols="auto" data-cy="footer-col-button">
        <b-button
          class="align-content-center"
          @click="aceitar()"
          data-cy="btn-footer-entendi"
        >
          Entendi
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "mol-footer",
  components: {},
  data() {
    return {
      aceiteRealizado: false
    };
  },
  mounted() {
    this.aceiteRealizado =
      sessionStorage.getItem("quarkclinic.mol.aceite") === "true";
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    urls() {
      return this.$store.getters.urls;
    }
  },
  methods: {
    aceitar() {
      this.aceiteRealizado = true;

      sessionStorage.setItem("quarkclinic.mol.aceite", "true");
    }
  }
};
</script>

<style scoped>
a {
  color: #1369ac;
}
.footer {
  padding: 10px;
  bottom: 0;
  position: fixed;
  width: 100%;
  z-index: 1000;
}
</style>
